<template>
  <d-modal
    :key="'popup-guardian-' + isVisible"
    :class="{ 'popup-guardians-form': true, 'is-hidden': !isVisible }"
    @close="onClosePopup"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template v-if="isEdit">
            <h4>Edycja opiekuna:
              <p class="mt-1 mb-0" style="font-weight: 100; color: #17c671">
                {{ data.name + ' ' + data.last_name }}
              </p>
            </h4>
          </template>
          <template v-else>Dodaj opiekuna</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="patients-form-guardians"
        tag="form">
        <div class="form-group">
          <validation-provider
            :rules="'required'"
            :name="'type'"
            v-slot="{ errors }">
            <div
              class="form-group"
              style="margin-bottom: 1.8rem;">
              <label class="title-box" :for="data.type">
                Typ opiekuna:
              </label>
              <v-select
                class="reservation-style reservation-style-select-mid"
                :options="guardianTypes"
                :reduce="type => type.value"
                v-model="data.type"
                placeholder="Wybierz rodzaj opiekuna"
                label="name">
                <template #search="{attributes, events}">
                  <d-input
                    class="input-for-select"
                    :state="errors.length ? 'invalid' : null"
                    :required="!data.type"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name }}
                  </div>
                </template>
              </v-select>
            </div>
            <div
              class="invalid-feedback"
              style="display: block; margin-top: -1.4rem;">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <d-row>
          <d-col cols="2" md="2" lg="6">
            <div class="form-group">
              <label for="name">
                Imię:
              </label>
              <validation-provider
                :rules="'required'"
                v-slot="{ errors }">
                <d-input
                  type="text"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.name"
                />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
          <d-col cols="2" md="2" lg="6">
            <div class="form-group">
              <label for="last_name">
                Nazwisko:
              </label>
              <validation-provider
                :rules="'required'"
                v-slot="{ errors }">
                <d-input
                  type="text"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.last_name"
                />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>
        <div class="form-group">
          <label for="name">
            PESEL:
          </label>
          <validation-provider
            :rules="'required|min:9'"
            v-slot="{ errors }">
            <d-input
              type="number"
              :state="errors.length ? 'invalid' : null"
              v-model="data.pesel"
            />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <d-row>
          <d-col cols="2" md="2" lg="6">
            <div class="form-group">
              <label for="phone">
                Telefon kontaktowy:
              </label>
              <validation-provider
                :rules="'required'"
                v-slot="{ errors }">
                <d-input
                  type="number"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.phone"
                />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
          <d-col cols="2" md="2" lg="6">
            <div class="form-group">
              <label for="email">
                Adres e-mail:
              </label>
              <validation-provider
                type="number"
                :rules="'required'"
                v-slot="{ errors }">
                <d-input
                  type="text"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.email"
                />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>
        <div class="form-group">
          <label for="city">
            Miejscowość:
          </label>
          <validation-provider
            :rules="'required'"
            v-slot="{ errors }">
            <d-input
              type="text"
              :state="errors.length ? 'invalid' : null"
              v-model="data.city"
            />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <label for="street">
            Ulica:
          </label>
          <validation-provider
            :rules="'required'"
            v-slot="{ errors }">
            <d-input
              type="text"
              :state="errors.length ? 'invalid' : null"
              v-model="data.street"
            />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <d-row>
          <d-col cols="3" md="3" lg="4">
            <div class="form-group">
              <label for="number_home">
                Numer domu:
              </label>
              <validation-provider
                :rules="'required'"
                v-slot="{ errors }">
                <d-input
                  type="text"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.number_home"
                />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
          <d-col cols="3" md="3" lg="4">
            <div class="form-group">
              <label for="number_local">
                Numer mieszkania:
              </label>
              <validation-provider
                :rules="'required'"
                v-slot="{ errors }">
                <d-input
                  type="text"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.number_local"
                />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
          <d-col cols="3" md="3" lg="4">
            <div class="form-group">
              <label for="post_code">
                Kod pocztowy:
              </label>
              <validation-provider
                rules="required"
                name="post_code"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.post_code" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="onClosePopup">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div
        v-if="!loaded"
        class="pb-3 pt-3 text-center overlay-loading">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import GuardianTypes from '@/data/guardian-types.js';

export default {
  name: 'patients-form-guardians-popup',
  props: {
    guardian: {
      default: null,
      type: Object
    },
    isVisible: {
      default: false,
      type: Boolean
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    onSubmitCallback: {
      default: () => {},
      type: Function
    },
    patientId: {
      required: true,
      type: Number
    }
  },
  computed: {
    guardianTypes () {
      return GuardianTypes;
    },
    isEdit () {
      return !!(this.guardian && this.guardian.id);
    }
  },
  watch: {
    'isVisible': function (newValue) {
      if (newValue) {
        this.preparePopup();
      }
    }
  },
  data() {
    return {
      data: {
        id: '',
        city: '',
        email: '',
        last_name: '',
        name: '',
        number_home: '',
        number_local: '',
        patient_id: '',
        pesel: '',
        phone: '',
        post_code: '',
        street: '',
        type: ''
      },
      loaded: false
    };
  },
  mounted () {
  },
  methods: {
    preparePopup () {
      if (this.guardian && this.guardian.id) {
        Object.assign(this.data, this.guardian);
      } else {
        this.data.id = '';
        this.data.patient_id = this.patientId;
        this.data.name = '';
        this.data.last_name = '';
        this.data.type = '';
        this.data.phone = '';
        this.data.email = '';
        this.data.street = '';
        this.data.number_home = '';
        this.data.number_local = '';
        this.data.city = '';
        this.data.pesel = '';
        this.data.post_code = '';
      }

      Vue.nextTick(() => {
        if (this.$refs['patients-form-guardians']) {
          this.$refs['patients-form-guardians'].reset();
        }

        this.loaded = true;
      })
    },
    validateForm () {
      FormUtils.validate(this.$refs['patients-form-guardians'], this.submitForm);
    },
    submitForm  () {
      let formDataToSend = {
        patient_id: this.data.patient_id,
        type: this.data.type,
        name: this.data.name,
        last_name: this.data.last_name,
        email: this.data.email,
        street: this.data.street,
        number_home: this.data.number_home,
        number_local: this.data.number_local,
        post_code: this.data.post_code,
        city: this.data.city,
        pesel: this.data.pesel,
        phone: this.data.phone
      };
      let endpointUrl = this.isEdit ? '/patients/guardians/update/' + this.data.id : '/patients/guardians/store';
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano opiekuna',
        successText: 'Wybrany opiekun został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje opiekuna nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.onSubmitCallback(true);
          this.onClosePopup();
        }
      });
    }
  }
}
</script>

<style lang="scss">
.popup-guardians-form {
  &.is-hidden {
    display: none!important;
    pointer-events: none!important;
  }
  .modal-dialog {
    max-width: 700px;
    .modal-content {
      .modal-header {
        text-align: center;
        justify-content: center;
      }
    }
  }
}

</style>
